// extracted by mini-css-extract-plugin
export var defaultWrapper = "_nm-3";
export var downloadButton = "_nm-4";
export var fileContainer = "_nm-9 _nm-7";
export var fileContainerBase = "_nm-7";
export var fileContainerFixedHeight = "_nm-8 _nm-7";
export var fileInfo = "_nm-5";
export var fileInfoWidthRestricted = "_nm-6";
export var fileType = "_nm-1";
export var fileTypeName = "_nm-2";
export var image = "_nm-0";
export var link = "_nm-b";
export var overflowEllipsis = "_nm-a";